import type { Id, RuntimeApplication } from "./types";

export const createApplicationCache = (() => {
  const cache = new Map<Id, RuntimeApplication>();

  return {
    getApplication: (id: Id) => cache.get(id),
    addApplication: (id: Id, application: RuntimeApplication) => {
      cache.set(id, application);
    },
    hasApplication: (id: Id) => cache.has(id),
  };
})();

export const APPLICATIONS_CACHED = createApplicationCache;
